import * as React from "react";
import { Link } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

export default class EvisitInEligible extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { userData, userTags } = this.props;
        logUI('MBHWeb.Evisits.Start.General.InEligible', new Date(), Tools.getURLPath(), userData, 'eVisits', 'General' + userTags());
    }

    render() {

        const { isFromCovid19ScreenerSurvey, serverData } = this.props;

        const covid19TestLocation = serverData && serverData.data && serverData.data.covid19TestLocation ? serverData.data.covid19TestLocation : null;

        return (
            <div id="evisit-action" className="row">
                <div className="col-12">
                    <label id="lblEVisitMessage">
                        You're not eligible to complete an eVisit.{' '}
                        {this.props.isMinor
                            ? <span>If you are a minor, you may be able to take an eVisit from your parent’s MyBSWHealth account if they are your proxy.<br /><br /></span>
                            : ' '
                        }
                        Patients must meet our age requirements, have their medical record account linked and have a Texas address listed in their medical record account. 
                        For assistance, please call the MyBSWHealth technical help desk {this.props.technicalHelpDeskHours} at <a href={"tel:" + this.props.technicalHelpDeskNumber} className="phone-link">{this.props.technicalHelpDeskNumber}</a>.<br /><br />
                    </label>
                    <div className="evisit-ineligible-btn-links">
                        <Link onClick={(e) => { logUI("MBHWeb.UI.Evisits.InEligible.FindDoctor.Clicked", new Date(), Tools.getURLPath()); }} className="btn-link-style" to={{ pathname: "/findcare" }}>FIND A DOCTOR</Link>
                        {isFromCovid19ScreenerSurvey && <Link className="btn-link-style" onClick={(e) => { logUI("MBHWeb.UI.Evisits.InEligible.Covid19TestingLocation.Clicked", new Date(), Tools.getURLPath()); }} to={{ pathname: covid19TestLocation }} target="_blank">FIND A COVID-19 TESTING LOCATION</Link>}
                    </div>
                </div>
            </div>
        );
    }
}